/* eslint-disable max-classes-per-file */
import { observable } from 'mobx';
import { persist, create } from 'mobx-persist';

class Sections {
  @persist('list') @observable value = [];

  @observable clear() {
    this.value = [];
  }
}
class Token {
  @persist @observable value = '';

  @observable clear() {
    this.value = '';
  }
}
class User {
  @persist('object') @observable value = {};

  @observable clear() {
    this.value = {};
  }
}

class Notification {
  @persist @observable PaymentValue = 0;

  @persist @observable EndingValue = 0;

  @observable clearPayment() {
    this.PaymentValue = 0;
  }

  @observable clearEnding() {
    this.EndingValue = 0;
  }
}

// const store = (window.store = new Store());
const notification = new Notification();
const userStore = new User();
const tokenStore = new Token();
const sectionsStore = new Sections();
const hydrate = create({
  storage: localStorage,
  jsonify: true,
});
hydrate(process.env.REACT_APP_LOCALSTORAGE_USER, userStore).then(() => {
  console.log({ userStore });
});
hydrate(process.env.REACT_APP_LOCALSTORAGE_TOKEN, tokenStore).then(() => {});
hydrate(
  process.env.REACT_APP_LOCALSTORAGE_SECTIONS,
  sectionsStore
).then(() => {});

export default {
  userStore,
  tokenStore,
  sectionsStore,
  notification,
};
